import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Home as HomeIcon, Building2, Check } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { stats, testimonials, trustedLogos } from '../data/mock';

export default function WhyXpertpests() {
  return (
    <div className="bg-white">
      <Header />
      <section className="bg-gradient-to-b from-slate-50 to-white pt-20 pb-16">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <p className="text-[#8BC53F] font-bold tracking-widest text-sm mb-3">WHY XPERTPESTS</p>
          <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight text-slate-900 leading-tight">Why Choose Xpertpests<br/>by Xpertpests?</h1>
          <p className="mt-6 text-slate-600 text-xl">Powering the best in pest with the industry’s leading software and solutions.</p>
        </div>
        <div className="max-w-5xl mx-auto px-6 mt-12 grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map(s => (
            <div key={s.label} className="text-center bg-white rounded-2xl p-7 shadow-sm border border-slate-100">
              <div className="text-5xl font-extrabold bg-gradient-to-br from-[#8BC53F] to-[#6FA82C] bg-clip-text text-transparent">{s.num}</div>
              <div className="text-sm text-slate-600 mt-2">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-extrabold tracking-tight text-slate-900 text-center max-w-3xl mx-auto">The End-to-End Solution for Your Pest Control Business</h2>
          <p className="text-slate-600 text-center max-w-3xl mx-auto mt-5 text-lg leading-relaxed">With the features and functionality you need to out-sell, out-service and out-perform the competition — whether you serve residential customers, commercial clients or both — PCOs who choose Xpertpests grow 55% faster on average.</p>
          <div className="mt-14 grid md:grid-cols-2 gap-7">
            {[{title:'Residential',icon:HomeIcon,color:'#8BC53F',items:['Get estimates, schedule appointments and update service needs','Manage autopay methods, view invoices and securely pay bills','View account info, service history, proof of service, documents']},{title:'Commercial',icon:Building2,color:'#6FA82C',items:['Set up service and billing for multiple service locations','Manage devices and alerts for multi-unit properties, including smart traps','Support integrated pest management, inspections and licensing']}].map((b) => {
              const Ico = b.icon;
              return (
                <div key={b.title} className="pp-lift bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
                  <div className="w-16 h-16 rounded-xl flex items-center justify-center text-white" style={{background:`linear-gradient(135deg, ${b.color}, ${b.color}cc)`}}>
                    <Ico className="w-8 h-8"/>
                  </div>
                  <h3 className="text-3xl font-extrabold text-slate-900 mt-5">{b.title}</h3>
                  <ul className="mt-5 space-y-3">
                    {b.items.map(i => (
                      <li key={i} className="flex items-start gap-3 text-slate-700">
                        <Check className="w-5 h-5 mt-0.5 flex-shrink-0" style={{color: b.color}}/>
                        <span>{i}</span>
                      </li>
                    ))}
                  </ul>
                  <Button asChild className="mt-6 bg-slate-900 hover:bg-slate-800 text-white">
                    <Link to="/features">View More Features <ArrowRight className="w-4 h-4 ml-2"/></Link>
                  </Button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <p className="text-sm font-bold tracking-[0.25em] text-slate-500 mb-8">TRUSTED BY</p>
          <div className="flex flex-wrap justify-center items-center gap-12">
            {trustedLogos.map(l => (
              <div key={l} className="text-2xl font-extrabold text-slate-400 hover:text-slate-700 transition">{l}</div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-7">
          {testimonials.map(t => (
            <div key={t.name} className="pp-lift bg-slate-50 rounded-2xl p-8">
              <p className="text-slate-700 leading-relaxed">“{t.quote}”</p>
              <div className="mt-5 flex items-center gap-3">
                <img src={t.avatar} className="w-12 h-12 rounded-full object-cover" alt={t.name}/>
                <div>
                  <div className="font-bold text-slate-900">{t.name}</div>
                  <div className="text-sm text-slate-600">{t.title}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
